import moment from 'moment';
import i18n from '@/js/i18n';

export const toDate = (value) => {
  if (value instanceof Date) {
    return formatDate(value);
  }

  if (new Date(value).toString() === 'Invalid Date') {
    return 'Invalid Date';
  }

  return formatDate(new Date(value));
};

export const isValidDate = (date) => {
  const formatAffichage = i18n.t('compte.dateDeNaissance.formatAffichage');
  return moment(date, formatAffichage, true).isValid();
};

// Pour le set
export const convertStringToDate = (date) => {
  const formatAffichage = i18n.t('compte.dateDeNaissance.formatAffichage');
  const dateSansEspace = date.replace(/\s/g, '');
  if (dateSansEspace.length == i18n.t('compte.dateDeNaissance.formatAffichage').length) {
    const momentDate = moment(date, formatAffichage);
    if (momentDate.isValid()) {
      const validDate = momentDate.toISOString();
      return validDate;
    }
  }

  return date;
};

/**
 *
 * @param {string} date lorsque valide, sera un string iso representant la date, garder en memoire
 * @param {boolean} langCourante specifie si on veut utiliser le local courant. Mettre false pour l'api
 *
 * @return {string} Retourne une string representant la date en fonction du local.
 */
export const convertDateToString = (date, langCourante = true) => {
  if (moment(date, moment.ISO_8601, true).isValid()) {
    let dateValue = null;
    if (langCourante) {
      dateValue = moment(date).format(i18n.t('compte.dateDeNaissance.formatAffichage'));
    } else {
      // Par defaut utilise le format francais(ou peut-etre le laisser en format iso?) pour formatter l'information pour l'api
      dateValue = moment(date).format(
        i18n.t(i18n.t('compte.dateDeNaissance.formatAffichage', 'fr'))
      );
    }
    return dateValue;
  }

  return date;
};

export const getAgeFromDate = (date, addDays = 0) => {
  const formatAffichage = i18n.t('compte.dateDeNaissance.formatAffichage');
  const momentDate = moment(date, formatAffichage).add(addDays, 'days');
  if (momentDate.isValid()) {
    const validDate = momentDate.toDate();
    const age = moment().diff(validDate, 'years');
    return age;
  }

  // Date invalide
  return null;
};

export const getCurrentDate = (format) => {
  return moment().format(format);
};

// This will be replace with moment later.
const formatDate = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
